<template>
    <component :is="component" :paginationData="paginationData"  :listLength="listLength" v-if="component" :type="type"/>
</template>

<script>
    export default {
        name: "PaginationLink",
        mixins: [],
        components: {},
        provide() {
            return {}
        },
        props: {
            paginationLayout: {

            },
            paginationData: {default: () => {return {total: 0, page: 0, size: 0,}}
            },
            listLength: {
                type: Number,
                default: 0
            },
            type: {},

        },
        data() {
            return {
                component: null,
            }
        },
        created() {},
        mounted() {
            this.templateLoader();

        },
        beforeDestroy() {},
        destroyed() {},
        computed: {
            loader() {
                if (!this.paginationLayout) {
                    return null
                }
                return () => import(`@/template/board/pagination/${this.paginationLayout}`)
            },
        },
        methods: {
            templateLoader() {
                if(this.loader === null) {
                    return false;
                }
                this.loader()
                    .then(() => {
                        this.component = () => this.loader()
                    })
                    .catch(() => {
                        this.component = () => import('@/template/board/pagination/PaginationDefaultLayout')
                    })
            },
        },
        watch: {},
    }
</script>

<style scoped>

</style>
